module.exports = __webpack_public_path__ + "img/button_one.23060b59.png";